import { reduceValuesWithIds } from '@common/utils/binding';
import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

export const currentRecordSelector = (state: RootState) =>
  state.database.currentRecord;

export const web3ConfigSelector = (state: RootState) =>
  state.database.web3Config;

export const realtimeDatabaseSelector = (state: RootState) =>
  state.database.databaseRefresh;

export const getCurrentRecord = (ids: string[]) =>
  createSelector(currentRecordSelector, reduceValuesWithIds(ids));

export const getCollectionSelector =
  (databaseUuid: string) => (state: RootState) =>
    state.database.collections.find(
      (item) => item.databaseUuid === databaseUuid
    );
